class WorksFilterToggle {
  constructor(root = document) {
    this.toggles = Array.from(root.querySelectorAll(".index-works__toggle"))
    this.panels = new Map()

    root.querySelectorAll(".index-works__panel").forEach(panel => {
      this.panels.set(panel.dataset.panel, panel)
    })

    this.toggles.forEach(button => {
      button.addEventListener("click", () => this.toggle(button))
    })
  }

  toggle(button) {
    const panel = this.panels.get(button.dataset.panel)
    if (!panel) return

    // Re-open only if it was closed, so clicking the open one collapses it.
    const open = panel.dataset.open !== "true"

    this.panels.forEach(el => (el.dataset.open = "false"))
    this.toggles.forEach(el => el.setAttribute("aria-expanded", "false"))

    if (open) {
      panel.dataset.open = "true"
      button.setAttribute("aria-expanded", "true")
    }
  }
}

export default WorksFilterToggle
